import React, { useEffect } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useGetBillHubAttachmentData } from '../../../../../hooks/useGetBillHubAttachmentData';
import { useStore } from '../../../../../../../store';
import { fileTypes } from '../../../components/PreviewAddAttachment/types';

interface IProps {
  documentIdFromResponse: string
}
const BillPreviewHasAttachment = ({ documentIdFromResponse } : IProps) => {
  const { customerId } = useStore(state => state.user);
  const getPersonalAccount = useStore(state => state.getPersonalAccount);
  const selectedBill = useStore(state => state.selectedBill);

  const { accountExternalId } = getPersonalAccount();

  const {
    mutate: mutateDownload, data: downloadData, isLoading,
  } = useGetBillHubAttachmentData({ customerId, accountExternalId, documentId: documentIdFromResponse || selectedBill!.documentId });

  useEffect(() => {
    mutateDownload();
  }, [selectedBill]);

  return (
    <div className='h-full'>
      {isLoading
        ? <Skeleton width='100%' height='100%' />
        : (
          <div className='h-full border-[1px] border-bw03'>
            {downloadData?.type === fileTypes.IMAGE && <img className='h-full w-full object-contain' src={downloadData!.url} alt='billsHub_attachmentPreviewImg' />}
            {downloadData?.type === fileTypes.PDF && (
            <iframe
              data-testid='billsHub_previewPDF'
              title='billsHub_attachmentPreviewPDF'
              className='w-full h-full'
              src={downloadData!.url}
            />
            )}
          </div>
        )}
    </div>
  );
};

export default BillPreviewHasAttachment;
